// extracted by mini-css-extract-plugin
module.exports = {"BodyFrame":"BodyFrame_BodyFrame__2SjAh"};